export const worksData = [
  {
    id: 'work-1',
    title: '熱きもの、感じるべし',
    category: 'FILM',
    year: 2024,
    videoUrl: 'https://www.youtube.com/embed/oxUYgzzg3O8',
    thumbnail: 'https://img.youtube.com/vi/oxUYgzzg3O8/maxresdefault.jpg',
    description: 'The Tokyo 48 Hour Film Project 2024\nプレミア上映会\n\n「熱きもの、感じるべし」New Age Cinema\n\n日時：6月8日（土）12:30〜　Group A\n会場：なかのZERO 西館　小ホール\n入場料：当日券のみ 1,000円／プログラム\n\n※詳細はこちらをご確認ください。\nhttps://x.com/Tokyo48hfp/status/1796125773084164433',
    credits: {
      director: 'EIJI HOSHINO',
      cinematography: 'EIJI HOSHINO',
      editing: 'EIJI HOSHINO',
      sound: 'MASAKI NAKADA',
      cast: 'SHINJI SONODA, etc.'
    }
  },
  {
    id: 'work-2',
    title: 'お熱いうちに',
    category: 'FILM',
    year: 2023,
    videoUrl: 'https://www.youtube.com/embed/pv54jOAGwes',
    thumbnail: 'https://img.youtube.com/vi/pv54jOAGwes/maxresdefault.jpg',
    description: 'The Tokyo 48 Hour Film Project 2023  参加作品\n\nキャスト：\nこのみ / 小門真也 / 横山大河 / 如月萌 / 牧野亜希子\n\nスタッフ：\n監督・脚本：ホシノエイジ\n音楽：中田征毅\n地図：ケロケロちゃむ\n脚本協力：中野そてっつ / 柏木俊彦\n制作：新田りょうじ',
    credits: {
      director: 'EIJI HOSHINO',
      cinematography: 'EIJI HOSHINO',
      editing: 'EIJI HOSHINO',
      music: 'MASAKI NAKADA',
      cast: 'SHINYA KOKADO, etc.'
    }
  },
  {
    id: 'work-3',
    title: '悲しみのパレード／樋口舞と天井桟敷アンサンブル',
    category: 'MV',
    year: 2014,
    videoUrl: 'https://www.youtube.com/embed/JdeXF5w2J-g',
    thumbnail: 'https://img.youtube.com/vi/JdeXF5w2J-g/maxresdefault.jpg',
    description: 'ミュージックビデオ\n\nYoutubeにて配信中（HD 5分）\n\nアーティスト：樋口舞と天井桟敷アンサンブル',
    credits: {
      director: 'EIJI HOSHINO',
      cinematography: 'EIJI HOSHINO',
      editing: 'EIJI HOSHINO',
      sound: 'MAI HIGUCHI'
    }
  }
];

export const newsData = [
  {
    date: '2026.02.08',
    title: 'サイトリニューアル'
  }
];
